import { render, staticRenderFns } from "./historyInfoComponent.vue?vue&type=template&id=01964a27&scoped=true&"
import script from "./historyInfoComponent.vue?vue&type=script&lang=js&"
export * from "./historyInfoComponent.vue?vue&type=script&lang=js&"
import style0 from "./historyInfoComponent.vue?vue&type=style&index=0&id=01964a27&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01964a27",
  null
  
)

export default component.exports